import { z } from 'zod';
import { EmailSchema, IDSchema, IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
/**
 * T-TEAM-001-FOUNDATION — UserTeamMembership join entity (data model §22).
 *
 * A `salesRep` user can belong to multiple Teams (canonical example: East
 * Coast + Medical). Used by the Account-inheritance rule in §21 to derive
 * opsAdmin visibility at query time (Q2 RESOLVED 2026-05-29 — DERIVED AT
 * QUERY TIME; Accounts carry NO `teamId`).
 *
 * No `role` discriminator within a team — V1 is just membership (rep in
 * team). opsAdmin "leads team X" lives on `UserRoleAssignment.scopeTeamIds`
 * (§20 addendum / Q5 RESOLVED 2026-05-29 — ON UserRoleAssignment, no separate
 * UserTeamLeadership table), NOT here. Separating membership from leadership
 * keeps the two concerns from conflating.
 *
 * At most one ACTIVE membership per (userEmail, teamId) — enforced by a
 * partial unique index `user_team_memberships_one_active_per_user_team`
 * WHERE deleted_at IS NULL. Soft-delete = rep left the team.
 */
export const UserTeamMembershipSchema = z.object({
    id: IDSchema,
    type: z.literal('user_team_membership'),
    schemaVersion: SchemaVersionSchema,
    userEmail: EmailSchema,
    teamId: IDSchema,
    joinedAt: IsoTimestampSchema,
    createdAt: IsoTimestampSchema,
    createdBy: z.string(),
    updatedAt: IsoTimestampSchema,
    updatedBy: z.string(),
    deletedAt: IsoTimestampSchema.nullable().optional(),
    version: z.number().int().positive(),
});
//# sourceMappingURL=user-team-membership.js.map